import React from "react";
import TabLink from './TabLink';

export default ({tabs, activeTab, onTabClick, countSupplements}) => {
    return (
        <ul className={`tabs__nav ${!tabs.length ? 'empty' : ''}`}>
            {
                tabs.map((tab, i) => { 
                    return (
                    <li key={i}>
                        <TabLink
                            heading={tab}
                            activeTab={activeTab}
                            index={i}
                            onTabClick={onTabClick}
                            counter={countSupplements}
                        />
                    </li>
                ) })
            }
        </ul>
    )
}
